import {modelsArrayToMapById} from '../../../shared/services';
import {fromJS, Map} from 'immutable';
import {
  LOAD_DASHBOARD_CHARACTERS_FULFILLED,
  LOAD_DASHBOARD_CHARACTERS_PENDING,
  LOAD_DASHBOARD_CHARACTERS_REJECTED,
  SELECT_DASHBOARD_CHARACTER,
} from '../../actions';

const initialState = Map({
  loading: false,
  dashboardCharacters: Map(),
  selectedDashboardCharacter: Map(),
});

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_DASHBOARD_CHARACTERS_PENDING:
      return state.set('loading', true);

    case LOAD_DASHBOARD_CHARACTERS_FULFILLED:
      return state.withMutations(map => map.set('loading', false)
          .set('dashboardCharacters', modelsArrayToMapById(action.payload.data))
          .set('selectedDashboardCharacter', Map(action.payload.data[0])));

    case LOAD_DASHBOARD_CHARACTERS_REJECTED:
      return state.set('loading', false);

    case SELECT_DASHBOARD_CHARACTER:
      return state.set('selectedDashboardCharacter', action.payload);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/dashboard/reducers/pages/list.js